// extracted by mini-css-extract-plugin
export default {"cardsSection":"styles_cardsSection__AbOqg","gamesWrapper":"styles_gamesWrapper__9MpOY","autoWidth":"styles_autoWidth__EXj4N","derbyMobileWrapper":"styles_derbyMobileWrapper__zTfvF"};